import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import { ETranslationStatus } from '../../../types/exam';

export interface TranslationIndicatorProps {
  readonly status: ETranslationStatus;
}

const statusMap: Record<
  ETranslationStatus,
  { status: 'default' | 'positive' | 'negative' | 'highlight' | 'helper' }
> = {
  [ETranslationStatus.PendingTranslation]: { status: 'highlight' },
  [ETranslationStatus.Translated]: { status: 'helper' },
  [ETranslationStatus.Reviewed]: { status: 'positive' },
  [ETranslationStatus.Outdated]: { status: 'negative' },
};

export function TranslationIndicator({ status }: TranslationIndicatorProps) {
  const { t } = useTranslation('examManagement');
  const key = ETranslationStatus[status] as keyof typeof ETranslationStatus;
  const label = t(`translation.status.${key}` as never);
  const config = statusMap[status];

  return <Tag label={label} size="md" status={config.status} custom={{ text: 'text-nowrap' }} />;
}
